const { courseCategoryList } = require("constants/courseCategory");

const initialState = {
  courseCategoryList: {},
};

const courseCategory = (state = initialState, action) => {
  switch (action.type) {
    case courseCategoryList:
      return { ...state, courseCategoryList: action.payload };

    default:
      return state;
  }
};

export default courseCategory;
